import { useState } from "react";
import { ReactComponent as MapToggleIcon } from "../../assets/svgs/icons/map-toggle-icon.svg";
import { MenubarContainer } from './Menubar.style';
import { Tooltip } from "antd";

const MapToggleBar = () => {
    const [tooltipVisible, setTooltipVisible] = useState(false);

    const handleToggleMap = () => {
        if (window?.potreeViewer?.scene?.pointclouds?.length === 0) {
            return;
        } else {
            window.potreeViewer.toggleMap();
        }
    }

    const handleMouseEnter = () => {
        if (window?.potreeViewer?.scene?.pointclouds?.length === 0) {
            setTooltipVisible(true);
        }
    }

    const handleMouseLeave = () => {
        setTooltipVisible(false);
    }

    return (
        <MenubarContainer>
            <Tooltip
                title="Map will be displayed once you load any data."
                placement="right"
                open={tooltipVisible}
            >
                <div
                    className="map_toggle_box"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <MapToggleIcon onClick={handleToggleMap} />
                </div>
            </Tooltip>
        </MenubarContainer>
    );
}

export default MapToggleBar;
